import FacebookMessengerShareIcon from "@apps/rewards/widgets/rewards_popup_root_widget/components/icons/SocialShareIcons/FacebookMessengerShareIcon.svelte";
import FacebookShareIcon from "@apps/rewards/widgets/rewards_popup_root_widget/components/icons/SocialShareIcons/FacebookShareIcon.svelte";
import PinterestShareIcon from "@apps/rewards/widgets/rewards_popup_root_widget/components/icons/SocialShareIcons/PinterestShareIcon.svelte";
import TwitterShareIcon from "@apps/rewards/widgets/rewards_popup_root_widget/components/icons/SocialShareIcons/TwitterShareIcon.svelte";
import WhatsAppShareIcon from "@apps/rewards/widgets/rewards_popup_root_widget/components/icons/SocialShareIcons/WhatsAppShareIcon.svelte";

import { REWARDS_REFERRAL_SHARE_CHANNELS } from "./constants";

export const REWARDS_REFERRAL_SHARE_ICONS = {
    [REWARDS_REFERRAL_SHARE_CHANNELS.facebookShare]: FacebookShareIcon,
    [REWARDS_REFERRAL_SHARE_CHANNELS.twitterShare]: TwitterShareIcon,
    [REWARDS_REFERRAL_SHARE_CHANNELS.whatsAppShare]: WhatsAppShareIcon,
    [REWARDS_REFERRAL_SHARE_CHANNELS.facebookMessengerShare]:
        FacebookMessengerShareIcon,
    [REWARDS_REFERRAL_SHARE_CHANNELS.pinterestShare]: PinterestShareIcon,
};
